import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { VALIDATION_CONTROLS_SERVICE_NAME } from '../../../../services/controls'
import { IMRBaseComponent } from "../../base"

import { IMRSelectGridInputFieldController } from "./select-grid.input-field.controller"

//#region Assets Imports

import './select-grid.input-field.scss'
import * as TEMPLATE from './select-grid.input-field.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrSelectGridInputField'

export class IMRSelectGridInputFieldComponent extends IMRBaseComponent {

    //#region Ctor

    public constructor() {
        super({
            controller: IMRSelectGridInputFieldController,
            services: [
                USER_SESSION_SERVICE_NAME,
                VALIDATION_CONTROLS_SERVICE_NAME
            ],

            bindings: {
                id: '=',
            },

            template: TEMPLATE
        })
    }

    //#endregion
}


